module.exports = __webpack_public_path__ + "media/images/athletes/2022-5c921271d39b274ddffccab3423bfd06.png";